<template>
  <section id="Privacy">
    <div class="row">
      <div class="title col-md-8 d-flex align-items-center justify-content-start ml-auto">
        <h1 class="h5">H'S VIBE齊來卡 隱私權保護聲明暨使用者條款</h1>
      </div>
      <div class="col-12">
        <div class="desc mt-30 p-50">
          <p>H'S VIBE齊來卡官方網站（以下簡稱本網站）係由「漢齊科技股份有限公司」（以下簡稱本公司）所經營，為尊重您個人資料之隱私權及保護您使用本網站之網路安全，我們謹以下列聲明（以下簡稱本聲明），向您說明本網站於線上蒐集您個人資料之目的、方式、範圍、運用以及就您所提供之個人資料得行使之相關權利等事項。您在使用本網站前，請詳細閱讀並遵從本聲明，確定了解本聲明內容，當您繼續使用本網站服務時，即視為已閱讀、了解並完全同意本聲明的所有約定，且同意本公司蒐集、處理及利用您的個人資料，如您不同意本聲明之內容，您應立即停止使用本網站。</p>
          <ol class="first p-0">
            <li>
              <h6>一、網站安全</h6>
              <p>為了網站安全的目的，本網站提供了以下的安全保護措施，並遵守個人資料保護法相關規定，以確保顧客使用本網站之安全及尊重個人資訊之隱私權：</p>
              <ol>
                <li>使用網路入侵偵測系統，監控網路流量，以防範未經授權而企圖上載或更改、網頁資訊或蓄意破壞者。</li>
                <li>為維護會員個人資料安全，本網站服務皆使用資料傳輸加密，並裝設防火牆防止非法入侵、破壞或竊取或破壞資料，盡可能避免個人資料外流並保障使用者的權益。</li>
                <li>裝設掃毒軟體，定期掃毒，以提供使用者更安全的網頁瀏覽環境。</li>
              </ol>
            </li>
            <li>
              <h6>二、自我保護措施</h6>
              <p>請妥善保管您的密碼或任何個人資料，不要將任何個人資料，尤其是密碼提供給任何人。在您登入系統完成各項作業後，務必記得登出帳號，若您是與他人共享電腦或使用公共電腦，切記要關閉瀏覽器視窗，以防止他人讀取您的個人資料、信件或進入所屬機關管理區。</p>
            </li>
            <li>
              <h6>三、網站管理</h6>
              <p>除本公司以外之任何人於本網站所發表的內容訊息及外部連結，本公司將不負任何責任，本公司得刪除本網站內任何危害其他方著作權或專利權等其他內容。若相關內容經認定為有害、具攻擊性、或有侵犯本條款與違法之情事，本公司得逕為刪除並依法通報相關單位。若經判定會員的行為不符合相關服務條款的要求和精神時，本公司得中斷對其提供本網站網路服務的權利，包含但不限於：</p>
              <ol>
                <li>不可使用網路服務作非法用途。</li>
                <li>不得公佈或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、違反公共秩序或善良風俗及其他不法之文字、圖片或任何形式的檔案。</li>
                <li>不得侵害或毀損本公司、本網站或他人之名譽、隱私權、或私自透露營業機密、或利用本服務侵犯任何與商標權、著作權、專利權、其他智慧財產權及其他權利。</li>
                <li>不干擾或混亂網路服務亦不得傳輸或散佈電腦病毒。</li>
                <li>不得行使未經本公司同意或授權之商業行為。</li>
                <li>不遵守所有使用網路服務的網路協定、規定、程式和慣例。</li>
              </ol>
            </li>
            <li>
              <h6>四、隱私權保護聲明</h6>
              <ol>
                <li>如您因加入本網站會員，或參與本網站活動而提供個人資料時，本公司將會依個人資料保護法之規定來蒐集、處理、利用及保管，以保障您的個人資料資訊之隱私權。</li>
                <li>您所提供之個人資料，可以依個人資料保護法之規定，在本公司營業時間申請查詢、閱覽或製給複製本，本公司依法得收取必要的費用。若所提供個人資料有變更或不正確時，可以申請補充或更正；當個人資料蒐集之特定目的消失時，除本公司執行業務或法律程序有留存必要，本公司將銷毀其個人資料，您也可以申請停止蒐集、處理、利用或刪除個人資料。</li>
                <li>您使用本網站所提供之服務時，其使用過程中所有的資料記錄，以本網站服務資料庫所記錄之資料為準，如有任何糾紛，以本服務資料庫所記錄之電子資料為認定標準。但消費者您如能提出其他資料並證明為真實者則不在此限。</li>
                <li>本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護聲明，您必須參考該連結網站中的隱私權保護政策，本公司不負其責。</li>
                <li>未滿12歲之兒童，因其識別能力及法律常識，尚不足辨識有關個人資料保護之約定及法定應告知事項之利害關係，請由其監護人代為申訴及提供個人資料，以保障其隱私及其他權益。至於未滿20歲之青少年亦建議由成年人審閱後再提供個人資料使用本網站之申訴服務。</li>
              </ol>
            </li>
            <li>
              <h6>五、個人資料使用條款</h6>
              <p>本公司對於您個人資料的蒐集、處理及利用，將遵守中華民國『個人資料保護法』之規範，並聲明如下：</p>
              <ol>
                <li>本公司將以為回應您的寶貴意見連繫及處理等相關作業為目的，於本公司營業所在地區及您之居住地區蒐集、處理、使用您提供之姓名、電話號碼、傳真號碼、電子郵件信箱、住址及申訴內容所提及之個人資料。如您不同意提供必需之個人識別或通訊資料，本公司可能無法提供服務，致影響您的權益。</li>
                <li>您所提供之個人資料，可以依個人資料保護法之規定，在本公司營業時間申請查詢、閱覽或製給複製本，本公司依法得收取必要的費用。若所提供個人資料有變更或不正確時，可以申請補充或更正；當個人資料蒐集之特定目的消失時，除本公司執行業務或法律程序有留存必要，本公司將銷毀您的個人資料，您也可以申請停止蒐集、處理、利用或刪除個人資料。</li>
                <li>您所提供的資料，將依據本公司資訊安全政策及規範提供最嚴格的管理及保護。</li>
              </ol>
            </li>
            <li>
              <h6>六、免責條款</h6>
              <p>
                本網站就各項服務或內容，不保證安全、無誤、穩定及不中斷。會員將會承擔使用本服務之所有風險及可能致生之任何損害。本公司不負賠償責任。故如遇到任何風險及可能致生之任何損害之虞時，請您應即停止使用本網站。
                <br />本網站上所有廣告，均由各該產品與服務的供應商所設計製作刊登，本網站僅提供網站供其刊登，對於廣告內容之正確性與可信度請您自行判斷，本公司並不負任何擔保責任。
              </p>
            </li>
            <li>
              <h6>七、隱私權政策之修訂與公告</h6>
              <p>隨著環境及法令的變遷，本公司將會不定時審議、修改或變更保護個人資訊管理及安全政策，並將依法更新公告於本網站，除法定通知義務外，不另行通知，請不定期檢視本網站規範及注意事項；有關條款之增訂、修改，如您於更新公告後繼續使用本服務，則視為您已經同意該修訂條款。</p>
            </li>
            <li>
              <h6>八、隱私權聲明之諮詢</h6>
              <p>若您對本網站的隱私權保護聲明暨使用者條款有任何問題，歡迎來信H'S VIBE齊來卡官方網站信箱: hsvibe@hichi-tech.com。</p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Privacy',
  metaInfo: {
    title: '隱私權條例 | ',
  },
};
</script>
<style lang="scss" scoped>
#Privacy {
  overflow: hidden;
  padding: 20px 0 100px;
  .title {
    border-bottom: 2px solid $primary-light;
  }
  .desc {
    background: linear-gradient(to right, white 30%, $secondary-white 120%);
    p {
      color: $secondary;
    }
    ol {
      &.first {
        list-style: none;
        > li {
          margin-top: 30px;
          h6 {
            margin-bottom: 5px;
          }
        }
      }
      ol{
        margin-top: 10px;
        >li{
          margin: 2px 0;
        }
      }
    }
  }
}
</style>
